//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuBarDefault from '~/components/menu/MenuBarDefault';
import MenuBarTabs from '~/components/menu/MenuBarTabs';
import CountryDropdown from '~/components/menu/CountryDropdown';
export default {
  data() {
    return {
      hoveredTimeout: null,
      visibleTimeout: null,
      active: null,
      visible: null
    };
  },
  props: {
    header: {
      type: Object,
      required: true
    }
  },
  components: {
    MenuBarDefault,
    MenuBarTabs,
    CountryDropdown
  },
  methods: {
    _getTemplate(menu) {
      return 'menu-bar-' + (menu.template || 'default');
    },
    onHover(index, event) {

      if(!this.header.menu[index].has_submenu) return;

      const self = this;

      clearTimeout(this.hoveredTimeout);
      clearTimeout(this.visibleTimeout);

      self.hoveredTimeout = setTimeout(function() {
        self.active = index;
        self.visible = index;

        document.querySelector('body').classList.add('nav--open');
      }, 50);
    },
    onLeave(index, event) {
      const self = this;

      clearTimeout(self.hoveredTimeout);
      clearTimeout(self.visibleTimeout);

      self.hoveredTimeout = setTimeout(function() {
        self.active = null;

        document.querySelector('body').classList.remove('nav--open');

        self.visibleTimeout = setTimeout(function() {
          self.visible = null;
        }, 250);
      }, 100);
    }
  },
  created() {
    if (process.browser) {
      const self = this;
      window.addEventListener('scroll', function() {
        self.active = null;
        self.visible = null;
      });
    }
  }
};
